import React from 'react';
import { useNavigate } from 'react-router-dom';

import './Projects.css';
import Card from '../ui/Card';

// cover image
import InsightTubeCover from './InsightTube/cover.png';
import WinnableCover from './Winnable/cover.png';
import IcyVillageCover from './IcyVillage/cover.png';
import FreshPotatoesCover from './FreshPotatoes/cover.png';
import PortfolioCover from './Portfolio/cover.png';
import JBrosPlumbingCover from './JBrosPlumbing/cover.jpeg';
import ZenbuCover from './Zenbu/cover.png';
import SumodleCover from './Sumodle/cover.png';
import GundamLinkCover from './GundamLink/cover.png';

function Projects({ ...props }) {
  const navigate = useNavigate();

  // Redirect to internal page
  function handleCardClick(projectId) {
    navigate(`/project/${projectId}`);
  }

  // Redirect to external page
  function handlePageRedirect(url) {
    if (url) window.open(url, '_blank', 'noopener noreferrer');
  }

  return (
    <div className="cards-container">
      <Card
        title="Gundam Link"
        description="A Card Trading Platform with Interactive Maps and Geospatial Features"
        extras="[2025 - Current]"
        coverImage={GundamLinkCover}
        coverImagePosition="center"
        onClick={() => handlePageRedirect('https://gundam-link.vercel.app/')}
      />
      <Card
        title="Sumodle"
        description="Daily Sumo Wrestler Guessing Game"
        extras="[2025]"
        coverImage={SumodleCover}
        coverImagePosition="center"
        onClick={() => handlePageRedirect('https://sumodle.com/')}
      />
      <Card
        title="Zenbu"
        description="Automated Website Data Processing & Visualization"
        extras="[2025]"
        coverImage={ZenbuCover}
        coverImagePosition="center"
        onClick={() => handlePageRedirect('https://zenbustats.netlify.app/')}
      />
      <Card
        title="J Bros Plumbing"
        description="Freelance Design & Development"
        extras="[2025]"
        coverImage={JBrosPlumbingCover}
        coverImagePosition="center"
        onClick={() => handlePageRedirect('https://jbrosplumbing.ca/')}
      />
      <Card
        title="Winnable"
        description="Full-Stack Development"
        extras="[2024]"
        coverImage={WinnableCover}
        coverImagePosition="center"
        onClick={() => handleCardClick('winnable')}
      />
      <Card
        title="InsightTube"
        description="Full-Stack Development"
        extras="[Coming Soon]"
        coverImage={InsightTubeCover}
        coverImagePosition="top"
        // onClick={() => handlePageRedirect('https://github.com/Kylet1699/InsightTube')}
        className="disabled-card"
      />
      <Card
        title="Portfolio"
        description="Front-End Design & Development"
        extras="[2022]"
        coverImage={PortfolioCover}
        coverImagePosition="center"
        onClick={() => handlePageRedirect('https://kyletseng-v1.netlify.app/')}
      />
      <Card
        title="Icy Village"
        description="Front-End Design & Development"
        extras="[2022]"
        coverImage={IcyVillageCover}
        coverImagePosition="center"
        onClick={() => handlePageRedirect('https://icy-village.netlify.app/')}
      />
      <Card
        title="Fresh Potatoes"
        description="Full-Stack Development"
        extras="[2021]"
        coverImage={FreshPotatoesCover}
        coverImagePosition="top"
        onClick={() => handleCardClick('freshpotatoes')}
      />
    </div>
  );
}

export default Projects;
